<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Shot types</div>
</div>

<div class="page-layout-small padding-large m-margin-none m-padding m-padding-top-largest">
  <bt-page-header title="Shot types" subtitle="Shots that order templates can request, and their legacy codes" icon="fa-solid fa-camera">
    <div class="flex center gap m-wrap">
      <button (click)="openCreateShotTypeModal()">
        <i class="fa-solid fa-plus margin-right-small"></i>
        Create shot type
      </button>
      <button class="stroked" (click)="goLegacyExportTemplate()">
        <i class="fa-solid fa-external-link margin-right-small"></i>
        Go to export templates
      </button>
    </div>
  </bt-page-header>

  <div class="flex wrap gap margin-bottom-small">
    <div class="filter-chip" [ngClass]="!shotTypeFilters.name ? '' : 'selected'">
      @if (shotTypeFilters.name) {
        <div class="flex center hover" (click)="openNameFilterModal()">
          <b class="margin-right-smallest">Name contains:</b>
          {{ shotTypeFilters.name }}
        </div>
        <mat-icon class="hover" (click)="cleanFilter('name')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openNameFilterModal()">
          Name
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  <div class="margin-top-small">
    @if (shotTypes.items && shotTypes.items.length) {
      <bt-paginator
        [pageNumber]="shotTypes.currentPage"
        [pageSize]="shotTypes.size"
        [totalNumber]="shotTypes.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>

      <table class="desktop-only">
        <tr>
          <!-- <th>Code</th>-->
          <th>Name</th>
          <!--  <th>Legacy code</th>-->
          <th>Order type</th>
          <th>In use</th>
          <th>Action</th>
        </tr>
        @for (item of shotTypes.items; track item.id) {
          <tr>
            <!--  <td>{{ item.code || '-' }}</td>-->
            <td>{{ item.name }}</td>
            <!-- <td>{{ getLegacyCodesLabel(item) }}</td> -->
            <td>{{ getOrderTypeLabel(item) }}</td>
            <td>
              @if (item.isInUse) {
                <span class="bg-orange radius padding-left-smallest padding-right-smallest">In use</span>
              } @else {
                <span class="grey">Not in use</span>
              }
            </td>
            <td class="nowrap">
              <div class="flex center gap">
                <span class="hover primary flex center" (click)="openEditShotTypeModal(item)">
                  <i class="fa-solid fa-edit small margin-right-smallest"></i>
                  Edit
                </span>
                <span
                  class="hover flex center red {{ item.isInUse ? 'disabled' : '' }}"
                  [matTooltip]="item.isInUse ? 'The shot type is in use: it cannot be removed' : ''"
                  (click)="deleteShotType(item)"
                >
                  <i class="fa-solid fa-trash small margin-right-smallest"></i>
                  Remove
                </span>
              </div>
            </td>
          </tr>
        }
      </table>

      <div class="mobile-only flex column gap">
        @for (item of shotTypes.items; track item.id) {
          <div class="border radius padding margin-bottom-small flex column gap">
            <div class="flex center between">
              <b>{{ item.name }}</b>
              @if (item.isInUse) {
                <span class="bg-green white radius padding-left-smallest padding-right-smallest">In use</span>
              } @else {
                <span class="grey">Not in use</span>
              }
            </div>
            <!-- <div>
              <b>Code:</b>
              {{ item.code || '-' }}
            </div>-->
            <div>
              <b>Legacy code:</b>
              {{ getLegacyCodesLabel(item) }}
            </div>
            <div>
              <b>Order type:</b>
              {{ getOrderTypeLabel(item) }}
            </div>
            <div class="flex end gap">
              <span class="hover primary flex center" (click)="openEditShotTypeModal(item)">
                <i class="fa-solid fa-edit small margin-right-smallest"></i>
                Edit
              </span>
              @if (!item.isInUse) {
                <span class="hover flex center red" (click)="deleteShotType(item)">
                  <i class="fa-solid fa-trash small margin-right-smallest"></i>
                  Remove
                </span>
              }
            </div>
          </div>
        }
      </div>

      <bt-paginator
        [pageNumber]="shotTypes.currentPage"
        [pageSize]="shotTypes.size"
        [totalNumber]="shotTypes.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>
    }

    @if (shotTypes.items.length == 0 && !loading) {
      <div class="flex center bg-light-grey padding-largest justify-center">
        <div class="flex column center gap">
          <i class="fa fa-search fa-2xl margin-bottom grey"></i>
          <span>No data found</span>
        </div>
      </div>
    }
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
